<h1 class="mf-popup-title">
    {{ popupTitle }}
</h1>

<div class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body">
        <div class="m-content">
            <form [formGroup]="addTermForm" (ngSubmit)="onSubmitNewTerm()" novalidate>
                <div>
                    <ng-template #rt let-r="result" let-t="term">
                        <strong>{{ r.name }} {{ r.surname }}</strong>
                        - {{ r.address }} {{ r.post }} {{ r.city }}
                    </ng-template>
                    <div *ngIf="addTermForm" class="pb-2">
                        <div class="row m-row--no-padding">
                            <div class="m-list-search">
                                <div class="m-list-search__results">
                                    <div *ngIf="isInputVisible.generictitleInput">
                                        <div class="m-list-search__result-item m-input-icon">
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Naziv interne rezervacije"
                                                    class="la la-i-cursor m--font-inverse-light"
                                                    i18n-ngbTooltip="@@7eea61f0f56751d4eebcc4a2e3529caf9e896d5a"
                                                ></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <input type="text" formControlName="generictitle" class="form-control m-input" />
                                            </span>
                                        </div>
                                        <div *ngIf="(addTermForm?.controls)['generictitle'].errors && isSubmited" class="m--font-danger pl-5">
                                            <small
                                                [hidden]="!(addTermForm?.controls)['generictitle'].errors.required"
                                                i18n="@@3da16016620cad384d0aca60311f7508b092df10"
                                            >
                                                Naziv je obvezno polje.
                                            </small>
                                        </div>
                                    </div>

                                    <div *ngIf="isInputVisible.customerInput" class="row m-row--no-padding">
                                        <div class="col-11">
                                            <div class="m-list-search__result-item m-input-icon">
                                                <span class="m-list-search__result-item-icon">
                                                    <i ngbTooltip="Stranka" class="la la-user m--font-inverse-light"></i>
                                                </span>
                                                <span class="m-list-search__result-item-text">
                                                    <input
                                                        [ngbTypeahead]="search"
                                                        [resultTemplate]="rt"
                                                        [inputFormatter]="formatter"
                                                        (ngModelChange)="onCustomerChange($event)"
                                                        type="text"
                                                        autofocus
                                                        placeholder="Poišči stranko"
                                                        formControlName="customer"
                                                        tabindex="1"
                                                        class="form-control m-input"
                                                    />
                                                </span>
                                                <span *ngIf="searching" class="loading-icon m-input-icon__icon m-input-icon__icon--right">
                                                    <span>
                                                        <div style="width: 30px; display: inline-block" class="m-loader m-loader--brand"></div>
                                                    </span>
                                                </span>
                                            </div>
                                            <div *ngIf="(addTermForm?.controls)['customer'].errors && isSubmited" class="m--font-danger pl-5">
                                                <small
                                                    [hidden]="!(addTermForm?.controls)['customer'].errors.required"
                                                    i18n="@@3f2a4ae8d38c57c82e30e93edfa5ac5e6f1269c0"
                                                >
                                                    Stranka je obvezno polje.
                                                </small>
                                            </div>
                                        </div>
                                        <div *ngIf="isInputVisible.isAddCustomerButtonVisible" class="col-1">
                                            <div class="pt-2">
                                                <a
                                                    (click)="openNewPatientDialog()"
                                                    hreg="#"
                                                    placement="top"
                                                    ngbTooltip="Registriraj novo stranko"
                                                    class="btn m-btn m-btn--hover-success m-btn--icon m-btn--icon-only m-btn--pill"
                                                    i18n-ngbTooltip="@@801931a289b12559d367bb5a89cac9cf0434c073"
                                                >
                                                    <i class="la la-user-plus m--font-inverse-light"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <term-form-customer-details
                                        *ngIf="resRequestData.reservationMode !== reservationTypes.INTERNAL"
                                        [setCustomer]="addTermForm?.getRawValue().customer"
                                        [parent]="addTermForm"
                                        (onFindSimilarCustomers)="findSimilarCustomers()"
                                        (onOpenCustomerEditForm)="openCustomerEditForm()"
                                    ></term-form-customer-details>

                                    <div
                                        *ngIf="
                                            addTermForm?.value.customer?.id &&
                                            (addTermForm?.value.customer.sendSms || addTermForm?.value.customer.sendMail)
                                        "
                                        class="pt-2"
                                    >
                                        <div class="m-list-search__result-item m-input-icon">
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Način obveščanja"
                                                    class="la la-bullhorn m--font-inverse-light"
                                                    i18n-ngbTooltip="@@6572efc93c050583cc46130c34b451f7d69a6794"
                                                ></i>
                                            </span>

                                            <label *ngIf="addTermForm?.value.customer.sendSms" class="m-checkbox m-checkbox--state-brand">
                                                <input
                                                    [checked]="addTermForm?.value.customer.sendSms"
                                                    type="checkbox"
                                                    formControlName="smsNotify"
                                                    i18n
                                                />
                                                SMS obveščanje
                                                <span></span>
                                            </label>
                                            <label
                                                *ngIf="addTermForm?.value.customer.sendMail"
                                                style="float: right"
                                                class="m-checkbox m-checkbox--state-brand mr-4"
                                            >
                                                <input
                                                    [checked]="addTermForm?.value.customer.sendMail"
                                                    type="checkbox"
                                                    formControlName="emailNotify"
                                                    i18n
                                                />
                                                EMAIL obveščanje
                                                <span></span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i
                                                ngbTooltip="Izvajalec storitve"
                                                class="la la-stethoscope m--font-inverse-light"
                                                i18n-ngbTooltip="@@53071fadc2548c8e8de41b3421d229d712e9a44f"
                                            ></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            <ng-select
                                                [items]="allSubcontractors"
                                                (change)="onSubConctractorChange($event)"
                                                bindLabel="name"
                                                tabindex="2"
                                                formControlName="subcontractor"
                                            >
                                                <ng-template ng-optgroup-tmp let-item="item">
                                                    {{ item.name }}
                                                </ng-template>
                                            </ng-select>
                                        </span>
                                    </div>
                                    <div *ngIf="(addTermForm?.controls)['subcontractor'].errors && isSubmited" class="m--font-danger pl-5">
                                        <small
                                            [hidden]="!(addTermForm?.controls)['subcontractor'].errors.required"
                                            i18n="@@ad546429d583e4cf139675c9c9260a53cdc7acba"
                                        >
                                            Izvajalec je obvezno polje.
                                        </small>
                                    </div>
                                    <!-- SERVICES -->
                                    <div *ngIf="isInputVisible.servicesInput">
                                        <!-- FAKE SERVICE -->
                                        <div *ngIf="isInputVisible.servicesFixedInput" class="m-list-search__result-item m-input-icon">
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Nosilna storitev"
                                                    class="la la-hand-paper-o m--font-inverse-light"
                                                    i18n-ngbTooltip="@@62d6803396ae2c32c9b7855af7812186913ca0f7"
                                                ></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <select
                                                    [compareWith]="equalsAnyById"
                                                    formControlName="services"
                                                    tabindex="3"
                                                    class="form-control m-input"
                                                >
                                                    <option></option>
                                                    <option [ngValue]="resRequestData.selectedService">
                                                        {{ resRequestData?.selectedService?.name }}
                                                    </option>
                                                </select>
                                            </span>
                                        </div>

                                        <div
                                            *ngIf="!isInputVisible.servicesFixedInput && (servicesForSubconstractor | async)"
                                            class="m-list-search__result-item m-input-icon"
                                        >
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Nosilna storitev"
                                                    class="la la-hand-paper-o m--font-inverse-light"
                                                    i18n-ngbTooltip="@@62d6803396ae2c32c9b7855af7812186913ca0f7"
                                                ></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <ng-select
                                                    [items]="servicesForSubconstractor | async"
                                                    [compareWith]="equalsAnyById"
                                                    (change)="onServiceChange()"
                                                    bindLabel="name"
                                                    tabindex="3"
                                                    groupBy="type"
                                                    formControlName="services"
                                                >
                                                    <ng-template ng-optgroup-tmp let-item="item">
                                                        {{ item.type | serviceTypePipe }}
                                                    </ng-template>
                                                </ng-select>
                                            </span>
                                        </div>
                                        <div
                                            *ngIf="(servicesForSubconstractor | async) && (addTermForm?.controls)['services'].errors && isSubmited"
                                            class="m--font-danger pl-5"
                                        >
                                            <small
                                                [hidden]="!(addTermForm?.controls)['services'].errors.required"
                                                i18n="@@2df4edfc4a59625ad3a581a1dd0b0439e6285476"
                                            >
                                                Storitev je obvezno polje.
                                            </small>
                                        </div>
                                    </div>

                                    <div
                                        *ngIf="isInputVisible.telemedicineInput && (addTermForm?.controls)['services']?.value"
                                        class="row m-row--no-padding"
                                    >
                                        <div *ngIf="isTelemedicineModuleActive" class="m-list-search__result-item m-input-icon col-sm-6 col-lg-6">
                                            <span class="m-list-search__result-item-icon">
                                                <i ngbTooltip="ePosvet" class="la la-video-camera m--font-inverse-light" i18n-ngbTooltip></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <span class="m-switch m-switch--outline m-switch--success d-flex">
                                                    <label class="mb-0">
                                                        <input type="checkbox" formControlName="telemed" />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </span>
                                        </div>

                                        <div *ngIf="isTelephonyModuleActive" class="m-list-search__result-item m-input-icon col-sm-6 col-lg-6">
                                            <span class="m-list-search__result-item-icon">
                                                <i ngbTooltip="Telefonski klic" class="la la-phone m--font-inverse-light"></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <span class="m-switch m-switch--outline m-switch--success d-flex">
                                                    <label class="mb-0">
                                                        <input type="checkbox" formControlName="phoneCall" />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="isHDActive && isInputVisible.telemedicineInput && (addTermForm?.controls)['services']?.value"
                                        class="row m-row--no-padding"
                                    >
                                        <div
                                            *ngIf="isTelemedicineModuleActive || isTelephonyModuleActive"
                                            class="m-list-search__result-item m-input-icon col-sm-12 col-lg-12"
                                        >
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Aplikacija"
                                                    class="la la-building m--font-inverse-light"
                                                    i18n-ngbTooltip="@@62d6803396ae2c32c9b7855af7812186913ca0f72"
                                                ></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <ng-select [items]="hdApps" bindLabel="name" tabindex="3" formControlName="hdApp">
                                                    <ng-template ng-optgroup-tmp let-item="item">
                                                        {{ item }}
                                                    </ng-template>
                                                </ng-select>
                                            </span>
                                        </div>
                                    </div>
                                    <div *ngIf="assets" class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i
                                                ngbTooltip="Prostor izvedbe"
                                                class="la la-sign-in m--font-inverse-light"
                                                i18n-ngbTooltip="@@b46f9ccd31f788002dfd87ad7f3292465866e059"
                                            ></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            <ng-select
                                                [items]="assets"
                                                [compareWith]="equalsAnyById"
                                                bindLabel="name"
                                                groupBy="assetType"
                                                formControlName="assets"
                                            >
                                                <ng-template ng-optgroup-tmp let-item="item">
                                                    {{ item.assetType | assetTypePipe }}
                                                </ng-template>
                                            </ng-select>
                                        </span>
                                    </div>
                                    <div *ngIf="(addTermForm?.controls)['assets'].errors && isSubmited" class="m--font-danger pl-5">
                                        <small
                                            [hidden]="!(addTermForm?.controls)['assets'].errors.required"
                                            i18n="@@41ce22d230654cf8583ca61577e74d96a0dd6c2a"
                                        >
                                            Prostor je obvezno polje.
                                        </small>
                                    </div>
                                    <span *ngIf="isInputVisible?.dateTime">
                                        <div class="row m-row--no-padding">
                                            <div class="m-list-search__result-item m-input-icon mb-2 col-sm-4 col-lg-4">
                                                <span class="m-list-search__result-item-icon">
                                                    <i
                                                        ngbTooltip="Datum termina"
                                                        class="la la-calendar m--font-inverse-light"
                                                        i18n-ngbTooltip="@@c735818db9ae8bc4378aca30b252cd7a9588995f"
                                                    ></i>
                                                </span>
                                                <span class="m-list-search__result-item-text">
                                                    <input
                                                        [options]="calendarOptions"
                                                        (selected)="setDate($event)"
                                                        type="text"
                                                        name="daterangeInput"
                                                        daterangepicker
                                                        formControlName="start"
                                                        class="form-control m-input"
                                                    />
                                                </span>
                                            </div>

                                            <div class="m-list-search__result-item mb-2 col-sm-4 col-lg-4">
                                                <span class="m-list-search__result-item-icon">
                                                    <i
                                                        ngbTooltip="Ura pričeteka termina"
                                                        class="la la-clock-o m--font-inverse-light"
                                                        i18n-ngbTooltip="@@d479b18a8e0491c98fdf12ba231020056edccf88"
                                                    ></i>
                                                </span>
                                                <span class="m-list-search__result-item-text">
                                                    <input
                                                        [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                                                        (change)="checkFunction($event)"
                                                        type="text"
                                                        placeholder="hh:mm"
                                                        formControlName="startTime"
                                                        class="form-control m-input"
                                                    />
                                                </span>
                                            </div>

                                            <div class="m-list-search__result-item mb-2 col-sm-4 col-lg-4">
                                                <span class="m-list-search__result-item-icon">
                                                    <i
                                                        ngbTooltip="Ura konca termina"
                                                        class="la la-step-forward m--font-inverse-light"
                                                        i18n-ngbTooltip="@@dae1d6238caf17d13f244ce600e7557c82d2fc82"
                                                    ></i>
                                                </span>
                                                <span class="m-list-search__result-item-text">
                                                    <input
                                                        [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                                                        type="text"
                                                        placeholder="hh:mm"
                                                        formControlName="endTime"
                                                        class="form-control m-input"
                                                    />
                                                </span>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-4 col-lg-4">
                                                <div *ngIf="(addTermForm?.controls)['start'].errors && isSubmited" class="m--font-danger pl-5">
                                                    <small
                                                        [hidden]="!(addTermForm?.controls)['start'].errors.required"
                                                        i18n="@@835f6ccdc53edd500b010db1111202ed9b1ed899"
                                                    >
                                                        Datum je obvezno polje.
                                                    </small>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 col-lg-4">
                                                <div *ngIf="(addTermForm?.controls)['startTime'].errors && isSubmited" class="m--font-danger pl-4">
                                                    <small
                                                        [hidden]="!(addTermForm?.controls)['startTime'].errors.required"
                                                        i18n="@@2824a6dd4aae7ba01f7e04c1ec7f6f7f0f24c93e"
                                                    >
                                                        Čas je obvezno polje.
                                                    </small>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 col-lg-4">
                                                <div *ngIf="(addTermForm?.controls)['endTime'].errors && isSubmited" class="m--font-danger pl-4">
                                                    <small
                                                        [hidden]="!(addTermForm?.controls)['endTime']?.errors?.required"
                                                        i18n="@@20a55cba861f95cbdd427cddd57907da70382e84"
                                                    >
                                                        Končni čas je obvezno polje.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                    <!-- ponavljajoče-->
                                    <div *ngIf="isRecurringModuleActive" class="row m-row--no-padding">
                                        <div
                                            *ngIf="isInputVisible.recurringInput"
                                            class="m-list-search__result-item m-input-icon mb-2 col-sm-6 col-lg-6"
                                        >
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Ponavljajoča rezervacija"
                                                    class="la la-retweet m--font-inverse-light"
                                                    i18n-ngbTooltip="@@1b94546043cdba3acc1871d2fd49dcef5abcf77d"
                                                ></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <ng-select
                                                    [items]="reacurringTypeTable"
                                                    [compareWith]="equalsAnyById"
                                                    [clearable]="false"
                                                    (change)="onRecurringChange($event)"
                                                    bindLabel="name"
                                                    formControlName="recurring"
                                                    tabindex="5"
                                                >
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <div title="{{ item.name }}">{{ item.name }}</div>
                                                    </ng-template>
                                                </ng-select>
                                            </span>
                                        </div>
                                        <div
                                            *ngIf="isInputVisible.recurringInput"
                                            class="m-list-search__result-item m-input-icon mb-2 col-sm-6 col-lg-6"
                                        >
                                            <span class="m-list-search__result-item-icon">
                                                <i
                                                    ngbTooltip="Ponavljaj do datuma"
                                                    class="la la-step-forward m--font-inverse-light"
                                                    i18n-ngbTooltip="@@02163ff6c662e319512e1bf3ffb2fba13fa1643a"
                                                ></i>
                                            </span>
                                            <span class="m-list-search__result-item-text">
                                                <input
                                                    [options]="calendarEmptyOptions"
                                                    (selected)="setRecurringDate($event)"
                                                    type="text"
                                                    name="dateInput"
                                                    daterangepicker
                                                    autocomplete="off"
                                                    formControlName="recurringUntil"
                                                    class="form-control m-input"
                                                />
                                            </span>
                                        </div>
                                    </div>

                                    <div *ngIf="isInputVisible.payer" class="row m-row--no-padding">
                                        <div class="col-11">
                                            <div class="m-list-search__result-item m-input-icon">
                                                <span class="m-list-search__result-item-icon">
                                                    <i ngbTooltip="Pravna oseba" class="la la-building"></i>
                                                </span>
                                                <span class="m-list-search__result-item-text">
                                                    <ng-select
                                                        [items]="invoicePartners$ | async"
                                                        [clearable]="true"
                                                        formControlName="payer"
                                                        tabindex="5"
                                                        bindLabel="name"
                                                        placeholder="Pravna oseba"
                                                    ></ng-select>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-1">
                                            <div class="pt-2">
                                                <a
                                                    (click)="openNewPayerDialog()"
                                                    hreg="#"
                                                    placement="top"
                                                    ngbTooltip="Dodaj pravno osebo"
                                                    class="btn m-btn m-btn--hover-warning m-btn--icon m-btn--icon-only m-btn--pill"
                                                >
                                                    <i class="la la-plus m--font-inverse-light"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i
                                                ngbTooltip="Posebna oznaka"
                                                class="la la-star"
                                                [ngClass]="(addTermForm?.controls)['customTag']?.value?.classColor || 'mf-custom-tag'"
                                                i18n-ngbTooltip="@@3cd2ad7b8e6ba51d2ebb3fadbbabe78f42525c9a"
                                            ></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            <ng-select
                                                [items]="customTags"
                                                [compareWith]="equalsAnyById"
                                                [clearable]="false"
                                                formControlName="customTag"
                                                tabindex="5"
                                                bindLabel="name"
                                            ></ng-select>
                                        </span>
                                    </div>

                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i
                                                ngbTooltip="Komentar rezervacije"
                                                class="la la-sticky-note m--font-inverse-light"
                                                i18n-ngbTooltip="@@ba89fb778ec0642800a1324da37cde33055b441f"
                                            ></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            <textarea formControlName="comment" rows="2" class="form-control m-input"></textarea>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer p-0 m-0">
            <button
                *ngIf="isTreatmentModuleActive && resRequestData.reservationMode !== reservationTypes.INTERNAL"
                (click)="openTreatment()"
                type="button"
                class="ml-auto mr-auto btn m-btn--pill btn-outline-success m-btn m-btn--custom"
            >
                Ustvari zdravljenje
            </button>

            <ng-container
                *ngIf="
                    resRequestData.reservationMode === reservationTypes.INTERNAL ||
                    resRequestData.reservationMode === reservationTypes.DRAFT ||
                    resRequestData.isEditMode
                "
            >
                <button (click)="deleteTerm()" type="button" class="ml-auto mr-auto btn m-btn--pill btn-outline-warning m-btn m-btn--custom">
                    Izbriši termin
                </button>

                <button
                    *ngIf="resRequestData?.event?.isRecurring"
                    (click)="createReservationFromReacurring()"
                    type="button"
                    class="ml-auto mr-auto btn m-btn--pill btn-outline-info m-btn m-btn--custom"
                    i18n="@@app.termForm.button.reacurring.createReservation.text"
                >
                    Odpri rezervacijo
                </button>
                <button
                    *ngIf="resRequestData.reservationMode === reservationTypes.DRAFT"
                    (click)="createReservationFromDraft()"
                    type="button"
                    class="ml-auto mr-auto btn m-btn--pill btn-outline-info m-btn m-btn--custom"
                    i18n="@@bd3d24ec6ba42f2bf8492380ae84dbf0257e7443"
                >
                    Ustvari rezervacijo
                </button>
            </ng-container>
        </div>
    </div>
</div>
